export const BASE_INSTAGRAM_URL = 'https://www.instagram.com/';
export const BASE_GITHUB_URL = 'https://github.com/';
export const BASE_X_URL = 'https://twitter.com/';
export const BASE_LINKEDIN_URL = 'https://linkedin.com/in/';
